module.exports = __webpack_public_path__ + "img/5@3x.09cce2f3.png";